const header = {
  name: "Giovanni Arizola",
  role: "Web Developer",
  resume:
    "https://firebasestorage.googleapis.com/v0/b/ga-storage.appspot.com/o/project-images%2Fga-current-resume-11_26.pdf?alt=media&token=7802da99-a2d3-486f-825a-9046872aa771",
  social: {
    github: "https://github.com/garizola",
    linkedin: "https://www.linkedin.com/in/giovanniarizola",
  },
};

const coSite = {
  name: "Custom Offsets",
  stack: "Take a look!",
  alt: "Custom Offset",
  sourceCode: "",
  livePreview: "https://customwheeloffset.com",
};

const projects = [
  {
    name: "Hudl Landing Page Example",
    stack: "Check out an example page!",
    alt: "Hudl Fan Solutions Landing Page",
    livePreview: "https://www.hudl.com/sports/football",
    sourceCode: "https://github.com/garizola/",
  },
  // {
  //   name: "Speak In Silence (WIP)",
  //   stack: " React, Tailwind, Rails, Postgres",
  //   alt: "Speak in Silence Landing Page",
  //   livePreview: "https://speak-in-silence.netlify.app/",
  //   sourceCode: "https://github.com/garizola/speak-in-silence_frontend",
  // },
  // {
  //   name: "Dormee (WIP)",
  //   stack: "React, Firebase Auth, Firestore",
  //   alt: "Dormee Landing Page",
  //   sourceCode: "https://github.com/garizola/",
  //   livePreview: "https://dormee.netlify.app/",
  // },

  // {
  //   name: "Omega Fitness",
  //   stack: "React, Axios w/ public APIs, Material UI",
  //   alt: "Omega Fitness Landing Page",
  //   sourceCode:
  //     "https://github.com/garizola/omega-fitness-react#react-fitness-app",
  //   livePreview: "https://omegafitness.netlify.app/",
  // },
];

export { header, projects, coSite };
